import { useMutation, useQueryCache } from "react-query";
import { postAdminResendMsg } from "../../api";
import { API_KEY_GET_ADMIN_CHATS } from "../../helpers";
export const usePostAdminResendMessage = () => {
  const queryCache = useQueryCache();
  return useMutation(postAdminResendMsg, {
    onSuccess: (data, variables) => {
      queryCache.invalidateQueries(API_KEY_GET_ADMIN_CHATS);
    },
  });
};
